module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Delegates.e3fb8391.svg";